import { filter, isEmpty, map } from 'lodash-es';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { CampaignType, ContactsList, Segment } from '@dev/ee-api/ee-api-models';
import { BLOCKED_CONTACTS_RULES, STALE_CONTACTS_RULES } from '@/services/dictionaries/ContactRules';
import { getCampainCreatorStore } from '@/store/campaignCreator/actions';
import { AutocompleteCategories, OptionProps } from '../SendToInterface';
import { isAllContactsOptionSelected } from '../../helpers';

export const useAutocompleteOptions = (
    lists: ContactsList[],
    segments: Segment[],
    chosenOptions: OptionProps[]
): OptionProps[] => {
    const { t } = useTranslation();
    const hasAllContactsOption = isAllContactsOptionSelected(chosenOptions);
    const hasAnyContactsOption = !isEmpty(chosenOptions.filter((value: OptionProps) => !value.isAllContacts));

    const { campaign } = useSelector(getCampainCreatorStore);
    const isAutomatedCampaign = campaign?.Type === CampaignType.Automated;

    const listsOptions = map(lists, (list) => ({
        label: list.ListName,
        disabled: hasAllContactsOption,
        category: AutocompleteCategories.List,
        isAllContacts: false,
    }));
    const segmentsOptions = filter(
        segments,
        (segment) => ![...BLOCKED_CONTACTS_RULES, ...STALE_CONTACTS_RULES].includes(segment.Rule)
    ).map((segment) => ({
        label: segment.IsAllContacts ? t('allcontacts') : segment.Name,
        disabled:
            (hasAllContactsOption && !segment.IsAllContacts) ||
            (hasAnyContactsOption && segment.IsAllContacts) ||
            (isAutomatedCampaign && !segment.IsAllContacts),
        category: AutocompleteCategories.Segment,
        isAllContacts: segment.IsAllContacts,
    }));

    return [...listsOptions, ...segmentsOptions];
};
